// imports
import clsx from 'clsx';
import React from 'react';
import GameHeader from './header';
import Utils from '../../common/utils';

// interfaces / types / consts
interface Props {
  items?: string[];
  backButtonText?: string;
  children: JSX.Element | JSX.Element[];
  backBtnClickedCB?: () => void;
}

// exports
export default function GameLayout(props: Props): JSX.Element {
  const {
    children, items, backBtnClickedCB, backButtonText
  } = props;
  const uniqueItems = items ? items.filter((item, idx) => items.indexOf(item) === idx) : [];
  // render
  return (
    <div className={clsx('game-layout', !Utils.dom.isMap() && 'wavy-bg')}>
      <GameHeader backBtnClickedCB={backBtnClickedCB!} items={uniqueItems} backButtonText={backButtonText} />
      {children}
    </div>
  );
}

// default props
GameLayout.defaultProps = {
  items: [],
  backButtonText: '',
  backBtnClickedCB: undefined
};
